import React from "react"
import PropTypes from "prop-types"
import * as css from "./Grid.module.css"

const Grid = ({ columns, children, gap }) => {
  if (parseInt(columns) === 1) {
    return <div className={`${css.list} items-list`}>{children}</div>
  }

  const classes = [css.grid, css[`columns_${columns}`]]

  return <div className={classes.join(" ")}>{children}</div>
}

Grid.propTypes = {
  columns: PropTypes.oneOf([1, 2, 3, 4, "2_3"]),
}

Grid.defaultProps = {
  columns: 3,
}

export { Grid }
